import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';

const MuiSelect = ({ value, onChange, options, placeholder, disabled = false, ...props }) => {
  return (
    <FormControl fullWidth>
      <Select
        value={value}
        onChange={onChange}
        displayEmpty
        disabled={disabled}
        sx={{
          borderRadius: '0.5rem',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#e5e7eb',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d1d5db',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#9ca3af',
          },
          '&.Mui-disabled': {
            backgroundColor: '#f3f4f6',
            cursor: 'not-allowed',
          },
          ...props.sx,
        }}
        {...props}
      >
        {placeholder && (
          <MenuItem value="">{placeholder}</MenuItem>
        )}
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MuiSelect;
